export { default, useImageLoader } from './Image'
